import { ref } from 'vue';
import { StatusEnum } from 'common';

export const numSubmitted = ref<number | string>('...');
export const numRejected    = ref<number | string>('...');
export const numAccepted = ref<number | string>('...');

export function newOverallNum(gr: StatusEnum, v: number) {
    switch (gr) {
        case StatusEnum.submitted:
            numSubmitted.value = v;
            break;
        case StatusEnum.rejected:
            numRejected.value = v;
            break;
        case StatusEnum.accepted:
            numAccepted.value = v;
            break;
    }
}